import { jsx } from 'react/jsx-runtime';
import { Tag } from '@flex-design-system/fx';
import { useTranslation } from '@flex-mf/i18n';
import { differenceInCalendarDays } from '@flexteam/date';
import { useNow } from '@flexteam/datetime-react/hooks';
import { useMemo } from 'react';
import '../apis/search/apis/advanced-filter-controller-api.mjs';
import '../apis/search/apis/department-search-action-controller-api.mjs';
import '../apis/search/apis/search-license-action-controller-api.mjs';
import '../apis/search/apis/search-user-template-api-controller-api.mjs';
import '../apis/search/apis/user-search-action-controller-api.mjs';
import '../apis/search/apis/user-search-controller-api.mjs';
import { SearchUserStatus } from '../apis/search/models/search-user-status.mjs';

function StatusTag({ userStatuses, companyJoinDate }) {
  const { t } = useTranslation();
  const now = useNow();
  const textContent = useMemo(() => {
    if (userStatuses.some(
      (currentStatus) => currentStatus === SearchUserStatus.CompanyJoinScheduled
    ) && companyJoinDate != null) {
      const remainDays = differenceInCalendarDays(companyJoinDate, now);
      return {
        color: "mango",
        text: `${t("@flex-services/user-avatar.domains.core-user.\uC785\uC0AC")} D-${remainDays}`
      };
    }
    if (userStatuses.some(
      (currentStatus) => currentStatus === SearchUserStatus.InEmploy
    ) && companyJoinDate != null) {
      const remainDays = differenceInCalendarDays(companyJoinDate, now);
      if (remainDays === 0) {
        return {
          color: "tropical",
          text: t("@flex-services/user-avatar.domains/core_status.\uC624\uB298\uC785\uC0AC")
        };
      }
    }
    if (userStatuses.some(
      (currentStatus) => currentStatus === SearchUserStatus.Resignation
    )) {
      return {
        color: "flame",
        text: t("@flex-services/user-avatar.domains/core_resignation.\uD1F4\uC9C1")
      };
    }
    if (userStatuses.some(
      (currentStatus) => currentStatus === SearchUserStatus.LeaveOfAbsence
    )) {
      return {
        color: "purpleLight",
        text: t("@flex-services/user-avatar.domains/core_absence.\uD734\uC9C1")
      };
    }
  }, [companyJoinDate, now, t, userStatuses]);
  if (textContent == null) {
    return null;
  }
  return /* @__PURE__ */ jsx(Tag, { size: "small", color: textContent.color, css: { marginRight: 6 }, children: textContent.text });
}

export { StatusTag as default };
//# sourceMappingURL=StatusTag.mjs.map
